module.exports = __webpack_public_path__ + "static/media/AwsDoc7.92494f00.png";